<div class="d-flex justify-content-center">
    <div class="card card-rounded card-shadow col-11 m-3">
        <div class="card-title">
            <h1 class="fw-bold m-3">List of Templates</h1>
            <p class="card-text m-3">
                The priority assigned to the template applies to all delivery methods, locales, and brands. Enable
                changes
                by clicking the Edit button and assign a priority.
                Click on the Event Type link to open the panel and select a priority based on Event Type.
            </p>
        </div>
        <hr class="hr m-3" />
        <div class="card-body">
            <span class="position-absolute top-10 end-0 pe-4 fs-5"
                [ngStyle]="{'color': '#5738FF', 'cursor': 'pointer', 'font-weight': 'bold'}"
                (click)="openModalClearAll()" *ngIf="editEnabled && !isLoadingActive">CLEAR ALL
            </span>
            <h4 class="fw-bold demand-response-template-title">Demand Response Template:</h4>
            <app-template-priority-loader *ngIf="templatesListIsLoading"
                [displayColumns]="12"></app-template-priority-loader>
            <div *ngIf="!templatesListIsLoading">
                <div class="row" *ngFor="let templatePriority of editedTemplatePriorities; let i = index">
                    <app-template-priority-switcher [templatePriority]="templatePriority" [index]="i"
                        [editEnabled]="editEnabled && !isLoadingActive" [eventTypes]="eventTypes" [lengthByScreen]="lengthByScreen"
                        [dropdownSelectedEntries]="dropdownSelectedEntries"
                        (update)="onUpdateTemplatePriority($event)"></app-template-priority-switcher>
                </div>
            </div>
        </div>
    </div>
</div>
<app-modal [openModalClearAll]="openModalClearAllStatus" (isOpenModalClearAll)="closeModalClearAll($event)" />